export default class BackInStock{

    constructor(){

        /* CONFIG */
        this.C = {
            product: window.product,
            button: document.getElementById('notify_button'),
            fields: {
                email: document.getElementById('notify_email'),
                accepts_marketing: document.getElementById('accept_marketing_check') || null
            }
        }

        // Attach Event
        this.attachEvent();
    }

    /**
     * @description
     * Show the message response returned from BackInStock App
     */
    showMessage(data){

        // Create message
        const msg = data.status === 'OK' ? data.message : Object.keys(data.errors).map((d) => data.errors[d].join());

        // Attach message
        let emsg = document.getElementById("stockCallback");
        emsg.className = '';
        emsg.classList.add(data.status);
        emsg.classList.add('active');
        emsg.innerHTML = msg;
    }

    /**
     * @description
     * Attach the event in the button "Avisa-me"
     */
    attachEvent(){
        const { button, product, fields: { email, accepts_marketing } } = this.C;
        let self = this;
        if(button){
            button.addEventListener("click", function(e){
                e.preventDefault();

                // BackInStock invocation and show response
                BIS.create(
                        email.value,
                        product.variants[0].id,
                        product.id,
                        { accepts_marketing: accepts_marketing ? accepts_marketing.value : false }
                    ).then(self.showMessage);
            });
        }
    }
}

// Fire Plugin
new BackInStock();